// extracted by mini-css-extract-plugin
export default {"header":"Header__header___i70m-","container":"Header__container___1IelO","tenant":"Header__tenant___-7Upd","image":"Header__image___2YnrM"};